// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3ibnz","requiredAsterisk":"Info_requiredAsterisk__2Q1kn"};